export default __webpack_public_path__ + "static/iphonemockup-1e102df09b6aab19b843ddd97e586fad.png";